import { Component, input } from '@angular/core';

@Component({
    selector: 'website-klaxoon-logo',
    templateUrl: './klaxoon-logo.component.html',
    host: { class: 'header-logo__image' },
})
export class KlaxoonLogoComponent {
    readonly isDarkTheme = input(false);
}
